import styled from 'styled-components';

export const SliderWrapper = styled.div`
  background: #1d2836;
  border-bottom: 5px solid var(--first-color);
`;
